//#region src/metadata/title.ts
const createTitle = () => ({ metadata }) => metadata.title;
//#endregion
export { createTitle };

//# sourceMappingURL=title.js.map